<section class="cart-empty d-flex">
    <app-svg-icon name="empty" class="my-4" />
    <span class="mat-headline-4 mb-3 text-center">Looks like your cart is empty.</span>
    @if (emptyMessage) {
        <p class="foreground-secondary mat-subtitle-1 text-center">{{ emptyMessage }}</p>
    }
    <button class="mat-subtitle-2" mat-button color="primary" (click)="back()">Back to home</button>
</section>
